import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { naira } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function WalletCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("verifying");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const ref = params.get("tx_ref") || params.get("reference") || params.get("trxref");
    if (!ref) {
      setState("failed");
      return;
    }
    api.get(`/wallet/topup/verify/${ref}`).then((r) => {
      if (r.data.status === "success") {
        setInfo(r.data);
        setState("success");
      } else {
        setState("failed");
      }
    }).catch(() => setState("failed"));
  }, [params]);

  return (
    <div className="min-h-screen bg-ink grain">
      <Navbar />
      <div className="pt-32 px-6 max-w-xl mx-auto" data-testid="wallet-callback">
        <div className="rounded-2xl bg-surface border border-white/10 p-10 text-center">
          {state === "verifying" && (
            <>
              <Loader2 className="w-10 h-10 mx-auto text-terracotta animate-spin mb-4" />
              <h1 className="font-display text-2xl font-bold mb-2">Verifying your top-up…</h1>
              <p className="text-foreground/60 text-sm">Just a moment.</p>
            </>
          )}
          {state === "success" && info && (
            <>
              <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-400 mb-4" />
              <h1 className="font-display text-3xl font-black mb-2">{naira(info.amount_naira)} added to your wallet</h1>
              <p className="text-foreground/70 mb-2">New balance: <span className="text-gold font-display font-bold">{naira(info.wallet_balance_naira)}</span></p>
              <p className="text-foreground/55 text-sm mb-6">Your funds are ready to spend on any approved film.</p>
              <div className="flex gap-3 justify-center flex-wrap">
                <Button onClick={() => navigate("/browse")} className="bg-terracotta hover:bg-ember text-white" data-testid="callback-browse-btn">Browse films</Button>
                <Button onClick={() => navigate("/wallet")} variant="outline" className="border-white/10">Back to wallet</Button>
              </div>
            </>
          )}
          {state === "failed" && (
            <>
              <XCircle className="w-12 h-12 mx-auto text-red-400 mb-4" />
              <h1 className="font-display text-3xl font-black mb-2">Top-up failed</h1>
              <p className="text-foreground/70 mb-6">We couldn't verify your transaction. Please try again from the wallet page.</p>
              <Button onClick={() => navigate("/wallet")} className="bg-terracotta hover:bg-ember text-white">Back to wallet</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
